import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Clock } from 'lucide-react';
import { Card } from './ui/card';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const pln = (v) => `${(v || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2 })} zł`;

// Read-only; render only for roles with full finance access
export const ProjectLabor = ({ projectId }) => {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API_URL}/godziny/project/${projectId}/labor`).then((r) => setData(r.data)).catch(() => setData(null)); }, [projectId]);
  if (!data) return null;
  return (
    <Card className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)] p-6" data-testid="project-labor-section">
      <h3 className="text-lg font-semibold text-[var(--crm-text-primary)] flex items-center gap-2 mb-3"><Clock className="w-5 h-5 text-[#FF6B35]" />Robocizna</h3>
      {!data.entries.length ? <p className="text-sm text-[var(--crm-text-muted)]">Brak zatwierdzonych godzin.</p> : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--crm-text-muted)]"><th className="p-1">Kto</th><th className="p-1">Kiedy</th><th className="p-1 text-right">Godziny</th><th className="p-1 text-right">Koszt</th></tr></thead>
          <tbody>
            {data.entries.map((e) => (
              <tr key={e.id} className="text-[var(--crm-text-secondary)]"><td className="p-1">{e.worker_name}</td><td className="p-1 font-mono">{e.date}</td>
                <td className="p-1 text-right">{e.hours} h</td><td className="p-1 text-right">{pln(e.cost)}</td></tr>
            ))}
            <tr className="font-semibold text-[var(--crm-text-primary)]" data-testid="project-labor-total"><td className="p-1" colSpan={2}>Razem</td>
              <td className="p-1 text-right">{data.total_hours} h</td><td className="p-1 text-right text-red-400">{pln(data.total_cost)}</td></tr>
          </tbody>
        </table>
      )}
    </Card>
  );
};
